import { ShownOutcome } from "../../shared/adjustedView";
import { IssueDescriptors } from "./AnalyticsProps";

/**
 * What happened in an outcome, as the tooltip of a risk chart tells it: with
 * whom the party settled (in the world of a settlement-adjusted outcome, its
 * pairs `a~b@stage` joined by `>`), and the claims it won and lost at
 * judgment, by their titles.
 */
export function whatHappened(
  outcome: ShownOutcome,
  partyId: string,
  names: { [partyId: string]: string | undefined },
  issues: IssueDescriptors,
): { settledWith: string[]; won: string[]; lost: string[] } {
  const settledWith = (outcome.world ?? "")
    .split(">")
    .filter(Boolean)
    .flatMap((step) => {
      const [first, second] = step.split("@")[0].split("~");
      const other =
        first === partyId ? second : second === partyId ? first : undefined;
      return other === undefined ? [] : [names[other] ?? other];
    });
  const titles = (ids: string[]) => [
    ...new Set(ids.map((id) => issues[id]?.title ?? id)),
  ];
  return {
    settledWith: [...new Set(settledWith)],
    won: titles(outcome.issuesWon),
    lost: titles(outcome.issuesLost),
  };
}
